import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  TextareaAutosize as BaseTextareaAutosize,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/system";
import { wait } from "@testing-library/user-event/dist/utils";
import { log } from "console";
import { AppraisalTask } from "../../all_Interfaces";
import { postApiCall } from "../../services/apiHelper";
import { TaskmgmtServiceURL } from "../../config/config";
import { ServiceName } from "../../constants";
import { useNavigate } from "react-router-dom";

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const TextareaAutosize = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 320px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${
      theme.palette.mode === "dark" ? grey[900] : grey[50]
    };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);

export const ApproveRejectComponent = (props: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [comments, setComments] = useState("");
  const [clickedButton, setClickedButton] = useState<string>("");
  const path = window.location.pathname;
  console.log(path);
  

  const returnToDashboard = () => {
    if (path.includes("/main/appraisal-form/") || path.includes("/main/debt-liability/")) {
      navigate("/main/dashboard")
    }
    else if(path.includes("/global/global-equity")){
      navigate("/global/dashboard")
    }
  }
  

  const handleOpen = (clickedButton: string) => {
    setOpen(true);
    if (clickedButton == "Approve") {
      setClickedButton("Approval");
    }
    if (clickedButton == "Reject") {
      setClickedButton("Rejection");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApprove = () => {
    // Add your approve logic here
    setOpen(false);
  };

  const handleConfirm = () => {
    console.log(comments);

    if (comments === "" && clickedButton == "Rejection") {
      props.isError({
        isError: true,
        message: "Please provide a comment for rejection.",
      });
      wait(2000).then(() => {
        props.isError({ isError: false, message: "" });
      });
    } else {
      addTaskDataToDB();
      setOpen(false);
    }
  };

  const addTaskDataToDB = () => {
    var taskObj = new AppraisalTask();
    taskObj.comments = comments;
    taskObj.taskStatus = clickedButton == "Approval" ? true : false;
    taskObj.appraisalStatus = props.status;
    taskObj.appraisalid = props.appraisalId;
    taskObj.workflowId = props.workflowId;
    taskObj.approver = props.userContext.displayName;
    taskObj.firstname = props.userContext.firstName;
    taskObj.lastname = props.userContext.lastName;
    taskObj.approverEmail = props.userContext.email;

    console.log(taskObj);

    postApiCall(
      TaskmgmtServiceURL +
        "/events?eventName=" +
        taskObj.appraisalStatus +
        "&eventKey=" +
        taskObj.workflowId,
      taskObj,ServiceName.TASKMANAGEMENTSERVICE
    )
      .then((data: any) => {
        props.isSuccess({
          isSuccess: true,
          message:
            "Appraisal has been " + (taskObj.taskStatus
              ? "approved"
              : "rejected"),
        });
        wait(2000).then(() => {
          props.isSuccess({ isSuccess: false, message: "" });
          returnToDashboard();
        });
      })
      .catch((e: any) => {
        props.isError({
          isError: true,
          message: "Appraisal task could not be completed",
        });
        wait(2000).then(() => {
          props.isError({ isError: false, message: "" });
        });
      });
  };

  return (
    <div className="text-right">
      <Button sx={{textTransform:"none",marginRight: 2}}
        variant="contained"
        size="medium"
        color="primary"
        onClick={() => handleOpen("Approve")}
      >
        Approve
      </Button>

      <Button sx={{textTransform:"none"}}
        variant="contained"
        size="medium"
        color="error"
        onClick={() => handleOpen("Reject")}
      >
        Reject
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          Enter Comment For {clickedButton}{" "} <span style={{color:'red'}}>{clickedButton == "Rejection" ? "*" : ""}</span>
          
        </DialogTitle>
        <DialogContent>
          <TextareaAutosize
            value={comments}
            autoFocus
            id="comment"
            aria-label="empty textarea"
            placeholder="Enter Comments Here..."
            minRows={7}
            onChange={(e) => setComments(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{textTransform:"none"}} onClick={handleConfirm} color="primary">
            Confirm
          </Button>
          <Button sx={{textTransform:"none"}} onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
